<template>
    <div class="row apprentice-simple-card">
         <div class="col-12 col-md-3">
             <ul class="nav nav-tabs nav-tabs-vertical subdomains-tab" role="tablist">
                 <li class="nav-item" v-for="(subDomain, key) in domain.sub_domains" :key="subDomain.id">
                     <a class="nav-link" :class="{'active': subDomain.id == selectedSubDomainId}" :ref="'sub-domain-nav-link-' + subDomain.id" data-toggle="tab"
                        :href="'sub-domain-tab-' + subDomain.id" role="tab" :aria-controls="subDomain.name"
                        :aria-selected="subDomain.id == selectedSubDomainId" @click="selectedSubDomainId = subDomain.id"
                        :style="headerStyle(subDomain)">
                            {{subDomain.name}}
                     </a>
                 </li>
             </ul>
         </div>

        <div class="col-12 col-md-9">
            <div class="tab-content">
                <div
                    v-for="(subDomain, key) in domain.sub_domains"
                    class="tab-pane fade" :class="{'show active': subDomain.id == selectedSubDomainId}"
                    :key="`${subDomain.id}-${subDomain.disciplineId}`"
                    :id="'sub-domain-tab-' + subDomain.id"
                    role="tabpanel" aria-labelledby="home-tab">
                    <div class="row">
                        <div class="subdomain-video col-12 col-md-6" v-for="video in subDomain.videos" :key="video.id" @click="playVideo(video.id)">
                            <div class="img-thumb">
                                <img class="mr-3" alt="Generic placeholder image" :src="video.thumbnail_url">
                                <p class="text-small duration mb-0">{{calcTimeInMinutes(video.duration)}}</p>
                            </div>

                            <div class="media-body">
                                <p class="mb-0 body-title">{{video.title}}</p>
                                <p class="teachers-info text-small mb-0">Docent: {{video.teacher.full_name}}</p>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "design-2021-digistudies-video-list",
        props: ['domain', 'discipline', 'subDomainId'],
        data() {
            return {
                videoList: {},
                selectedSubDomainId: this.subDomainId,
            }
        },
        created() {
        },
        methods: {
            calcTimeInMinutes(elapsedTime) {
                if(elapsedTime > 0) {
                    return parseFloat(parseInt(elapsedTime) / 60 - 0.15).toFixed(2);
                }
                return null;
            },
            // ToDo: Make global available
            makeHachTags(rawText){
                let cleanText = rawText.replace(/[^0-9]+/g, '');
                return rawText.replace(/[^A-Za-z]+/g,"-").toLowerCase();
            },
            playVideo(pid){
                window.location.href = baseUrl+'/videos/video/'+pid;
            },
            headerStyle(subDomain) {
                return (subDomain.id == this.selectedSubDomainId)
                    ? {'background-color': this.discipline.color}
                    : {};
            }
        }
    }
</script>

<style scoped>
    .subdomains-tab {
        margin-bottom: 30px;
    }
    .subdomain-video {
        margin-bottom: 30px;
        cursor: pointer;
        padding-bottom: 15px;
    }

    .discipline-videos {
        margin-bottom: 30px;
    }

    .header {
        padding: 11px;
        color: #fff;
        margin-bottom: 10px;
    }

    .img-thumb {
        width: 100%;
        position: relative;
    }
    .img-thumb img {
        width: 100%;
    }
    .duration {
        font-weight: 400;
        position: absolute;
        right: 5px;
        bottom: 5px;
        padding: 5px;
        color: #fff;
        background-color: #76838f;
    }

    .media-body {
        margin-top: 10px;
    }

    .teachers-info {
        color: #76838f;
    }

    .body-title,
    .duration,
    .teachers-info {
        margin: 0;
        line-height: 1.4;
    }

    a.nav-link.active {
        color: #fff;
    }

    a.nav-link:hover {
        background-color: inherit;
    }

    .media {
        cursor: pointer;
        flex-direction: column;
        border-bottom: 1px solid #e3e3e3;
    }
    .media:not(:last-child) {

        margin-bottom: 21px;
    }

    .body-title {
        font-weight: bold;
        font-size: 1rem;
        color: #000;
    }

    @media (min-width: 768px) {
        .media {
            flex-direction: row;
        }
        .list-unstyled:before{
            display: block;
            content: " ";
            margin-top: -80px;
            height: 80px;
            visibility: hidden;
            pointer-events: none;
        }
    }

</style>
